// extracted by mini-css-extract-plugin
module.exports = {"global_modal":"GlobalModal_global_modal__3ETgs"};